






import { Component, Prop, Vue } from "vue-property-decorator";
import { Const } from "@/const";

import * as def from "@/definitions";
import { ImageHelper } from '@/helper/imageHelper';
import { StringHelper } from '@/helper/stringHelper';
import { FileHelper } from '@/helper/fileHelper';
import { ExcelHelper } from '@/helper/excelHelper';
import { DebugHelper } from "@/helper/debugHelper";

import * as Encoding from 'encoding-japanese';

@Component({
  components: {
  }
})
export default class FileOpen2 extends Vue 
{
    // fileType
    public static readonly FILETYPE_IMAGE = "filetype_image";
    public static readonly FILETYPE_DOCUMENT = "filetype_document";
    public static readonly FILETYPE_TEXT = "filetype_text";
    public static readonly FILETYPE_EXCEL = "filetype_excel";

    private fileType = "";
    private callback : any = null; 

    private accept = "";
    private readType = "";
    private mimeType = "";
    private fileName = "";

    // コンポーネントを再読み込みすることで、入力をリセットする
    private isRefreshView : boolean = true;
    private refreshView(completion : () => void)
    {
        this.isRefreshView = false;
        this.$nextTick(() => 
        {
            this.isRefreshView = true;
            this.$nextTick(() =>
            {
                completion();
            });
        });
    }

    // 開く
    public open(fileType : string, callback)
    {
        this.fileType = fileType;
        this.callback = callback;

        if(fileType == FileOpen2.FILETYPE_IMAGE)
        {
            this.accept = "image/jpeg,image/png,image/gif,image/bmp,image/svg+xml";
            this.readType = "image";
        }
        else if(fileType == FileOpen2.FILETYPE_DOCUMENT)
        {
            this.accept = ".project" + "," + Const.PROJECT_FILE_EXTENSION + "," + Const.INSERTION_FILE_EXTENSION + "," + ".lcx,.lcxt";
            this.readType = "arrayBuffer";
        }
        else if(fileType == FileOpen2.FILETYPE_TEXT)
        {
            this.accept = ".txt";
            this.readType = "string";
        }
        else if(fileType == FileOpen2.FILETYPE_EXCEL)
        {
            this.accept = ".csv,.xlsx";
            this.readType = "arrayBuffer";
        }

        this.refreshView(() => 
        {
            var input = this.$refs.input as HTMLElement;
            input.click();
        });
    }

    private onFileChange(e)
    {
        var files : FileList = e.target.files || e.dataTransfer.files;

        // ファイルの選択をキャンセルした
        if (files.length <= 0) return;
        
        // ファイルを取得
        var file : File = files[0];
        // mimeTypeの保持
        this.mimeType = file.type;
        // ファイル名の保持
        this.fileName = file.name;

        // ファイルリーダーを作成
        var reader : FileReader = new FileReader();
        reader.onload = this.onLoadFile;
        // readTypeによりリーダーを振り分けて実行する
        if (this.readType == "image") reader.readAsDataURL(file);
        else if(this.readType == "arrayBuffer") reader.readAsArrayBuffer(file);
        else if(this.readType == "string") reader.readAsText(file);
    }

    private onLoadFile(e)
    {
        var result = e.target.result;
        if (result == null) return;

        var data : string | ArrayBuffer | null = null;
        if (this.readType == "image" || this.readType == "string")
        {
            // テキストを取得
            data = result as string;
        }
        else if(this.readType == "arrayBuffer")
        {
            // バイナリを取得
            data = result as ArrayBuffer;
        }

        if(data != null)
        {
            // コールバックを実行する
            if(this.callback != null)
            {
                this.callback({
                    readType : this.readType,
                    mimeType : this.mimeType,
                    fileName : this.fileName,
                    data : data
                });
            }
        }
    }

}
